import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { func, shape, string } from 'prop-types';
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { ZIndex } from "../../../internal/ZIndex";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { styles } from "../ToastView.styles";
export var ToastView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ToastView, _React$Component);

  function ToastView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.theme = void 0;

    _this.renderMain = function (props) {
      var action = props.action,
          onClose = props.onClose,
          rest = _objectWithoutPropertiesLoose(props, ["action", "onClose"]);

      var link = action ? /*#__PURE__*/React.createElement("span", {
        "data-tid": "ToastView__action",
        className: styles.link(_this.theme),
        onClick: action.handler
      }, action.label) : null;
      var close = action ? /*#__PURE__*/React.createElement("span", {
        className: styles.closeWrapper(_this.theme)
      }, /*#__PURE__*/React.createElement("span", {
        "data-tid": "ToastView__close",
        className: styles.close(_this.theme),
        onClick: onClose
      }, /*#__PURE__*/React.createElement(CrossIcon, null))) : null;
      return /*#__PURE__*/React.createElement(ZIndex, {
        priority: "Toast",
        className: styles.wrapper()
      }, /*#__PURE__*/React.createElement("div", _extends({
        "data-tid": "ToastView__root"
      }, rest, {
        className: styles.root(_this.theme)
      }), /*#__PURE__*/React.createElement("span", null, _this.props.children), link, close));
    };

    return _this;
  }

  var _proto = ToastView.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  };

  return ToastView;
}(React.Component);
ToastView.propTypes = {
  /**
  * Adds action handling and close icon for toast
  */
  action: shape({
    label: string.isRequired,
    handler: func.isRequired
  }),

  /**
  * Toast content
  */
  children: string.isRequired,
  onClose: func
};